import { tRatingProcessStepCommittee } from 'services/rating-process-step-committee';
import { tRatingMatrixFramework } from 'services/rating-matrix-framework';

const API = 'RatingProcessStepCommitteeRatingMatrixFramework';

export const API_RATING_PROCESS_STEP_COMMITTEE_RATING_MATRIX_FRAMEWORK = {
  API,
  GET_ALL_DYNAMIC: `${API}/GetAllDynamic`,
  POST: `${API}/Create`,
  PATCH: ({ id }: Pick<tRatingProcessStepCommitteeRatingMatrixFramework, 'id'>) =>
    `${API}/Patch/${id}`,
  DELETE: ({ id }: Pick<tRatingProcessStepCommitteeRatingMatrixFramework, 'id'>) =>
    `${API}/Delete/${id}`,
};

export type tRatingProcessStepCommitteeRatingMatrixFramework = {
  id: number;
  ratingProcessStepCommitteeID: number;
  ratingMatrixFrameworkID: number;
  ratingMatrixFrameworkTemplateID: number | null;

  ratingProcessStepCommittee?: tRatingProcessStepCommittee;
  ratingMatrixFramework?: tRatingMatrixFramework;
};

